import clsx from 'clsx';
import { generateTestId } from './data';

export interface BadgeProps {
  dataTestId: string;
  text: string | number;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
  status: 'success' | 'error' | 'warning' | 'info' | 'neutral' | 'primary';
  variant?: 'default' | 'outlined';
  disabled?: boolean;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  className?: string;
}

const Badge = (props: BadgeProps) => {
  const { dataTestId, text, icon: Icon, status, variant, disabled, size = 'medium', className } = props;

  const testIds = generateTestId(dataTestId);

  const badgeClasses = clsx('inline-flex items-center rounded-full font-medium border', {
    'bg-success-500 border-success-500 text-white': status === 'success' && variant === 'default',
    'bg-error-500 border-error-500 text-white': status === 'error' && variant === 'default',
    'bg-warning-500 border-warning-500 text-white': status === 'warning' && variant === 'default',
    'bg-secondary-500 border-secondary-500 text-white': status === 'info' && variant === 'default',
    'bg-gray-500 border-gray-500 text-white': status === 'neutral' && variant === 'default',
    'bg-primary-500 border-primary-500 text-white': status === 'primary' && variant === 'default',

    'bg-white border-gray-800 text-gray-800': variant === 'outlined',

    'opacity-60': disabled,

    'text-[12px] px-2 py-0.5': size === 'xsmall',
    'text-xs px-2 py-1': size === 'small',
    'text-sm px-3 py-2': size === 'medium',
    'text-base px-5 py-3': size === 'large',
  });

  return (
    <span data-testid={testIds.component} className={clsx(badgeClasses, className)}>
      {Icon && (
        <Icon
          className={`mr-1 ${size === 'xsmall' ? 'h-4 w-4' : 'h-5 w-5'} ${(status === 'primary' && 'text-primary-500') || (status === 'neutral' && 'text-white') || (status === 'info' && 'text-secondary-500') || (status === 'success' && 'text-success-500') || (status === 'error' && 'text-error-500') || (status === 'warning' && 'text-warning-500')}`}
        />
      )}
      {text}
    </span>
  );
};

export default Badge;
